import React, { Fragment, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Upload, Divider } from 'antd'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import RingtoneIcon from 'components/icons/Ringtone'
import DownLoadIcon from 'components/icons/DownLoad'
import UploadIcon from 'components/icons/UploadIcon'
import {
  StyledUpload,
  UploadFlex,
  UploadIconDiv,
  UploadFileDiv,
  FileNameDiv,
  HeadTextWrap,
  SubText,
  FirstContent,
  SampleDocWrapper,
  SampleDocIcon,
  SampleDocContent,
  SampleDocTitle,
  SampleDocSubtitle,
} from './style.js'
import { FooterFlex } from 'modules/Drives/DownloadAndUpload/DownloadCandidateDrawer/style'
import { uploadFile } from 'modules/ManageProfile/actions'
import FileReader from 'components/Uploader/FileReader'
import DullIcon from '../../../../components/icons/DullIcon'
import SmileIcon from '../../../../components/icons/SmileIcon'
import { ResultWrapper, StyledH2 } from '../style'
import Control from 'components/Control/Control'
import { StyledP } from '../style'

const UploadOfferDrawer = ({
  isOfferDrawer,
  setIsOfferDrawer,
  setIsDrawer,
  downloadCandidateSampleTemplate,
  handleOfferConfirm,
  setIsModalOpen,
  fileURL,
  setFileURL,
  file,
  setFile,
  offerType,
  bulkUploadResult,
  setBulkUploadResult,
  setErrorMessage,
  setOtherError,
  setIsFileLoader,
  setLoading,
  finalUpload,  
  setFinalUpload,
  otherError,
  isFileLoader,
  loading,
  handleClearUpload
}) => {
  const dispatch = useDispatch()

  const onClose = () => {
    setIsOfferDrawer(false)
    setIsDrawer(true)
    setFile(null)
    setFileURL('')
    setOtherError('')
  }

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('OK')
    }, 0)
  }


  const onChangeFileUpload = async info => {
    setIsFileLoader(true)

    if (info?.file?.status === 'done') {
      setFile(info?.file)
      let response = await dispatch(
        uploadFile(info?.file?.originFileObj, info?.file?.name)
      )
      if (response) {
        await setFileURL(response)
        setIsFileLoader(false)
        setOtherError('')
      }
    }
    
  }
  const content = () => {
    return (
      <>
        {/* Note Section */}
       
        {/* Sample Template Download */}
        <SampleDocWrapper onClick={downloadCandidateSampleTemplate}>
          <SampleDocIcon>
            <DownLoadIcon />
          </SampleDocIcon>
          <SampleDocContent>
            <SampleDocTitle>Candidate Document</SampleDocTitle>
            <SampleDocSubtitle>To bulk upload, use template</SampleDocSubtitle>
          </SampleDocContent>
        </SampleDocWrapper>

        {/* File Upload Area */}
        <StyledUpload
          multiple={false}
          type="file"
          accept={'.xlsx,.xls,.csv'}
          customRequest={dummyRequest}
          onChange={onChangeFileUpload}
          itemRender={() => null}
        >
          <UploadFlex column alignCenter style={{ marginTop: '20px' }}>
            <UploadIconDiv>
              <UploadIcon />
            </UploadIconDiv>
            <UploadFileDiv>Browse for file or Drag and drop</UploadFileDiv>
            <FileNameDiv>Format (.xls, .xlsx, .csv)</FileNameDiv>
          </UploadFlex>
          {fileURL && (
            <FileReader
              file={file}
              setFile={setFile}
              fileURL={fileURL}
              setFileURL={setFileURL}
              setErrorMessage={setErrorMessage}
            />
          )}
        </StyledUpload>
        {file === null && (
        <FirstContent>
        <HeadTextWrap>
          <RingtoneIcon />
          Please note!
        </HeadTextWrap>
        <SubText>Upload only the offer issued students!.</SubText>
        <SubText>
          Syncing candidates with Mail ID/Mobile Number is mandatory!
        </SubText>
      </FirstContent>
        )}
       
        {file && Object?.keys(bulkUploadResult)?.length !== 0 && (
                  <Control column top="40px" bottom="2px">
                    {Number(bulkUploadResult?.data?.matchedCandidateIds?.length) >
                    0 ? (
                      <ResultWrapper alignCenter>
                        <SmileIcon />
                        <StyledH2>
                          {Number(
                            bulkUploadResult?.data?.matchedCandidateIds?.length
                          )}
                          &nbsp;student
                          {bulkUploadResult?.data?.matchedCandidateIds?.length > 1
                            ? 's'
                            : ''}
                          {Number(
                            bulkUploadResult?.data?.matchedCandidateIds?.length
                          ) > 1
                            ? ' are '
                            : ' is '}
                          successfully shortlisted.
                        </StyledH2>
                      </ResultWrapper>
                    ) : (
                      <ResultWrapper alignCenter>
                        <DullIcon />
                        <StyledH2>
                          No candidates match for the above sheet
                        </StyledH2>
                      </ResultWrapper>
                    )}
                    {Number(bulkUploadResult?.data?.conflictCandidates?.length) >
                      0 && (
                      <>
                        <ResultWrapper alignCenter>
                          <DullIcon />
                          <StyledH2>
                            <>{'Status conflict with '}</>
                            {bulkUploadResult?.data?.conflictCandidates?.length}
                            {bulkUploadResult?.data?.conflictCandidates?.length >
                            1
                              ? ' students'
                              : ' student'}
                          </StyledH2>
                        </ResultWrapper>
                        {bulkUploadResult?.data?.conflictCandidates?.length !==
                          0 && (
                          <Control column top="10px">
                            <Button.Danger
                              wordBreak
                              text={'Resolve Conflicts'}
                              width="max-content"
                              onClick={() => handleResolveConflict()}
                            />
                          </Control>
                        )}
                      </>
                    )}
                    {bulkUploadResult?.data?.rejectionCandidateIds?.length !==
                        0 && (
                        <Control column top="30px">
                          {finalUpload == 0 && (
                            <StyledP>
                              Is this the last batch you are uploading?
                            </StyledP>
                          )}
                          {finalUpload > 0 && (
                            <StyledP>
                              {stage === 'offer' || conflictStatus === 'ACCEPTED'
                                ? `Do you want to mark all the other students as “Offer
                  declined”`
                                : `Do you want to reject the other candidates who weren't selected?`}
                            </StyledP>
                          )}

                          <Control top="8px" gap="5%">
                            <Button.Secondary
                              text="No"
                              onClick={() => isFinalUpload(-1)}
                            />
                            <Button.Primary
                              text="Yes"
                              onClick={() => isFinalUpload(+1)}
                            />
                          </Control>
                        </Control>
                      )}
                  </Control>
                )}
      </>
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd centerVertically>
        <Button.Secondary width="88px" text="Cancel" onClick={()=>onClose} />
        <Button.Primary
          width="110px"
          text={file === null ? "Next" : "Update"}
          loading={loading}
          onClick={()=>handleOfferConfirm(offerType)}
        />
      </FooterFlex>
    )
  }

  return (
    <>
      <Drawer
        width="40%"
        title={'Bulk Upload'}
        placement="right"
        visible={isOfferDrawer}
        content={content()}
        footer={footer()}
        onClose={onClose}
        closable
      />
    </>
  )
}

export default UploadOfferDrawer
